import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { DashboardContext } from "./DashboardContext";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

export const FileModal = () => {
    const { reportOpen, setReportOpen, fileUrl, fileName,handleDownload,allReports, setAllReports, blobPath, setBlobPath,
       setFileName, setFileUrl, setReportName, setReportNo, setPatientName,patientName, reportName, reportNo,currentFilter, setCurrentFilter } = useContext(DashboardContext);
    const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
    const [error, setError] = useState(null);

    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;

    const handleClose = () => {
        setReportOpen(false);
        setPdfBlobUrl(null);
        setError(null);
        setFileUrl(null);
    };

    const handleCustomDownload = async () => {
        if (!fileUrl) return;

        const res = await fetch(fileUrl);
        const blob = await res.blob();

        const customFileName = `${reportNo}_${reportName}.pdf`;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = customFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    useEffect(() => {
        if (!fileUrl || !reportOpen) return;

        const loadPdf = async () => {
            try {
                const res = await fetch(fileUrl);
                if (!res.ok) throw new Error(`Failed to fetch PDF. Status: ${res.status}`);

                const blob = await res.blob();
                if (blob.type !== "application/pdf") {
                    throw new Error("The file returned is not a PDF");
                }

                const blobUrl = URL.createObjectURL(blob);
                setPdfBlobUrl(blobUrl);
            } catch (err) {
                // console.error("PDF load error:", err);
                setError(err.message);
            }
        };

        loadPdf();

    }, [fileUrl, reportOpen]);

    if (!reportOpen) return null;

    return (
        <>
        <Modal show={reportOpen} onHide={handleClose} size="lg" centered backdrop="static" className="filemodal-dialog">
            <div className="filemodal-header p-2 border-bottom">
                <div className="report-info ms-3 mt-2 ">
                    <h6><strong>Report No: </strong>{reportNo}</h6>
                    <h6><strong>Report Name: </strong>{reportName}</h6>
                </div>

                <button type="button" className="btn-close me-3" onClick={handleClose}></button>
            </div>


            {/* Toolbar */}
            <div className="border-bottom p-2">
                <Toolbar>
                    {(slots) => {
                        const { ZoomIn, ZoomOut, Print, Download } = slots;
                        return (
                            <div className="d-flex gap-2 justify-content-end pdf-toolbar">
                                <ZoomOut />
                                <ZoomIn />
                                <Print />
                                {/* <Download /> */}
                                 <button className="custom-download-btn" onClick={handleCustomDownload}><i className="bi bi-download"></i></button>
                            </div>
                        );
                    }}
                </Toolbar>
            </div>
            <div className="p-1 pdf-viewer-container">
                {error && (
                    <div style={{ color: "red" }}>
                        <p>Error loading PDF: {error}</p>
                        <a href={fileUrl} download={`${reportNo}_${reportName}.pdf`}>
                            Download here
                        </a>
                    </div>
                )}

                {!error && pdfBlobUrl && (
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer fileUrl={pdfBlobUrl} plugins={[toolbarPluginInstance]} />
                    </Worker>
                )}

                {!error && !pdfBlobUrl && (
                    <div className="d-flex justify-content-center align-items-center h-100" style={{ color: "#00ABEF" }}>
                        <span className="spinner-border spinner-border-xl me-2" role="status" aria-hidden="true"></span>
                    </div>
                )}
            </div>
        </Modal>
        <style>
            {`
                .custom-download-btn {
                    width: 32px;
                    color: rgba(0, 0, 0, 0.7);
                    border: none;
                    background: transparent;
                    padding: 3px;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: background-color 0.2s;
                }

                .custom-download-btn:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                }

            `}
        </style>
        </>
    );
};
